import { EntityType, Tournament } from "./enums";

export const DetailTabs = {
    UPI: [],
    NETC: ["Amount", "Volume", "No of Banks Live", "Tag Issuance"],
} as const;

export const HEADING_STRINGS = {
    PAYMENTS_VALUE: "Payments Value (in Cr)",
    FASTAG_MONTHLY_VOLUME: "Fastag Monthly Volume",
    PAYMENT_VOLUME: "Payment Volume (in Mn)",
    FASTAG_MONTHLY_AMOUNT: "Fastag Monthly Amount",
    BANK_PARTICIPATION: "Bank Participation and Increase in Tag Issuance",
    TAGS_ISSUED: "No of Tags Issued",
    FASTAG_AMOUNT_AND_VOLUME: "Fastag Monthly Amount  and Volume",
    PAYMENTS_VALUE_AND_VOLUME: "Payments Value (in Cr) and Volume (in Mn)",
};

export const EVENT_NAME = {
    SESSION_START: "session_start",
    LOGIN_SUCCESS: "login_success",
    LOGIN_FAILURE: "login_failure",
    LOGOUT: "logout",
    HOME_CLICK: "home_click",
    ABOUT_US_CLICK: "about_us_click",
    ABOUT_US_OPEN: "about_us_open",
    DISCOVER_CLICK: "discover_click",
    CRICKET_CLICK: "cricket_click",
    DISCOVER_OPEN: "discover_open",
    CRICKET_OPEN: "cricket_open",
    EXPLORE_CLICK: "explore_page_loaded",
    QUERY_CLICK: "explore_query_submitted",

    // v2 revamp
    ASK_DATAMUNI_CLICK: "ask_datamuni_page_loaded",
    EXPLORE_V2_CLICK: "explore_v2_page_loaded",
};

export const EVENT_CATEGORY = {
    SESSION: "Session",
    AUTHENTICATION: "Authentication",
    NAVIGATION: "Navigation",
    ACTION: "Action",
};

export const EVENT_ACTION = {
    APP_START: "App Start",
    PAGE_LOAD: "Page Load",
    USER_LOGIN: "User Login",
    USER_LOGOUT: "User Logout",
    CLICK: "Click",
};

export const SOCIAL_MEDIA_LINKS = {
    TWITTER: "https://x.com/thedatamuni",
    INSTAGRAM:
        "https://www.instagram.com/thedatamuni/profilecard/?igsh=MWZoN243cjVha2I3eg==",
    LINKEDIN: "https://www.linkedin.com/company/thedatamuni/",
    YOUTUBE: "https://www.youtube.com/thedatamuni",
};

export const NAV_LINKS = [
    { name: "Privacy Policy", href: "/privacy-policy" },
    { name: "Terms of Service", href: "/terms-of-services" },
    { name: "About Us", href: "/about-us" },
];

export const TIME_RANGE_MAPPING: Record<number, string> = {
    1: "1 min",
    5: "5 min",
    15: "15 min",
    30: "30 min",
    0: "Today",
    60: "1Hr",
};

export const INTERNATIONAL_LEAGUE_MATCHES = [
    "Domestic-Firstclass",
    "Domestic-Lista",
    "100 ball",
    "in_tten",
    "Domestic-T20",
];

export const CRICKET_MATCH_TYPE_ID_TO_DISPLAY_TYPE_MAP = {
    "1": "Test",
    "2": "ODI",
    "3": "T20I",
    "4": "Test",
    "5": "Test",
    "6": "T20",
    "7": "T10I",
    "21": "Test",
    "22": "ODI",
    "23": "T20I",
    "71": "Test",
    "72": "ODI",
    "73": "T20",
    "78": "100 Ball",
};

export const ENTITY_TO_ENDPOINT_MAPPING: Record<EntityType, string> = {
    [EntityType.CRICKET]: "sport/cricket/series",
    [EntityType.FOOTBALL]: "sport/football/series",
    [EntityType.MOVIE]: "movie/series",
};

export const TOURNAMENT_TO_ENDPOINT_MAPPING: Record<Tournament, string> = {
    [Tournament.IPL2024]: "Indian%20Premier%20League,%202024",
    [Tournament.IPL2025]: "Indian%20Premier%20League,%202025",
    [Tournament.CHAMPIONS_TROPHY]: "ICC%20Champions%20Trophy,%202025",
};

export const CRICKET_MATCH_TYPE_TO_DISPLAY_TYPE_MAP = {
    T20I: "T20I",
    ODI: "ODI",
    Test: "Test",
    "Domestic-T20": "T20",
    "Non-Domestic-T20": "T20",
    "Domestic-Firstclass": "Test",
    "Domestic-Lista": "Test",
    "100 ball": "100 ball",
    in_tten: "T10",
    "Youth Test": "Test",
    "Youth ODI": "U19 ODI",
    "Youth T20I": "U19 T20I",
};

export const TOURNAMENT_SLUG_TO_TITLE_MAP = {
    "icc-champions-trophy-2025": "ICC Champions Trophy 2025",
    "ipl-2025": "Indian Premier League 2025",
    "indian-premier-league-2024": "Indian Premier League 2024",
    "icc-world-test-championship-final-2025":
        "World Test Championship Final 2025",
    // "new-zealand-in-india-3-test-series-2024":
    //     "New Zealand in India 3 Test Series 2024",
    "anderson-tendulkar-trophy-2025": "Anderson Tendulkar Trophy 2025",
};

export const TOURNAMENT_TITLE_TO_SLUG_MAP = {
    "ICC Champions Trophy 2025": "icc-champions-trophy-2025",
    "Indian Premier League 2025": "ipl-2025",
    "Indian Premier League 2024": "indian-premier-league-2024",
    "World Test Championship Final 2025":
        "icc-world-test-championship-final-2025",
    // "New Zealand in India 3 Test Series 2024":
    //     "new-zealand-in-india-3-test-series-2024",
    "Anderson Tendulkar Trophy 2025": "anderson-tendulkar-trophy-2025",
};

export const TOURNAMENT_SLUG_TO_SHORT_TITLE_MAP = {
    "champions-trophy-2025": "CT 2025",
    "ipl-2025": "IPL 2025",
    "ipl-2024": "IPL 2024",
    "wtc-final-2025": "WTC Final",
    "anderson-tendulkar-trophy-2025": "Anderson Tendulkar Trophy 2025",
    // "new-zealand-in-india-3-test-series-2024":
    //     "New Zealand in India Test Series 2024",
};

export const TOURNAMENT_SLUG_TO_CATEGORY_MAP = {
    "champions-trophy-2025": "Champions Trophy",
    "ipl-2025": "IPL,IPL 2025",
    "ipl-2024": "IPL,IPL 2024",
};

export const TOURNAMENT_DETAIL_PAGE_TAB_NAME = {
    LIVE: "Live",
    SUMMARY: "Summary",
    SCOREBOARD: "Scoreboard",
    COMMENTARY: "Commentary",
    STATS: "Stats",
    SQUAD: "Squads",
    PLAYING_XI: "Playing XI",
    FANTASY: "Fantasy",
    PREDICTION_EVENTS: "Prediction Events",
};

export const seriesSlugToCategoryValueMap = {
    "champions-trophy-2025": "Champions Trophy",
    "ipl-2025": "IPL,IPL 2025",
    "ipl-2024": "IPL,IPL 2024",
};

export const WicketType = {
    RETIRED_HURT: "dismissal_type_meta_rh",
    RUN_OUT: "run out",
    RETIRED_OUT: "dismissal_type_meta_rto",
};

export enum FormatType {
    TEST = "TEST",
    ODI = "ODI",
    T20I = "T20I",
    DomesticFirstclass = "Domestic-Firstclass",
    DomesticLista = "Domestic-Lista",
    DomesticT20 = "Domestic-T20",
    HundredBall = "100 ball",
    InTten = "in_tten",
    YouthTest = "Youth Test",
    YouthODI = "Youth ODI",
    YouthT20I = "Youth T20I",
    NonDomesticTest = "Non-Domestic-Test",
    NonDomesticODI = "Non-Domestic-ODI",
    NonDomesticT20 = "Non-Domestic-T20",
}

export const CompTypeIdToFormat: Record<string, FormatType> = {
    "1": FormatType.TEST,
    "2": FormatType.ODI,
    "3": FormatType.T20I,
    "11": FormatType.TEST,
    "12": FormatType.ODI,
    "13": FormatType.T20I,
    "4": FormatType.DomesticFirstclass,
    "5": FormatType.DomesticLista,
    "6": FormatType.DomesticT20,
    "78": FormatType.HundredBall,
    "7": FormatType.InTten,
    "21": FormatType.YouthTest,
    "22": FormatType.YouthODI,
    "23": FormatType.YouthT20I,
    "71": FormatType.NonDomesticTest,
    "72": FormatType.NonDomesticODI,
    "73": FormatType.NonDomesticT20,
};

export const CompTypeIdToFormatArchive: Record<string, FormatType> = {
    "1": FormatType.TEST,
    "2": FormatType.ODI,
    "3": FormatType.T20I,
    "11": FormatType.TEST,
    "12": FormatType.ODI,
    "13": FormatType.T20I,

    "6": FormatType.DomesticT20,
};

export const CompTypeIdToFormatUpcoming: Record<string, FormatType> = {
    "1": FormatType.TEST,
    "2": FormatType.ODI,
    "3": FormatType.T20I,
    "11": FormatType.TEST,
    "12": FormatType.ODI,
    "13": FormatType.T20I,
};

export const TournamentFilters = {
    International: [FormatType.TEST, FormatType.ODI, FormatType.T20I],
    Domestic: [
        FormatType.DomesticFirstclass,
        FormatType.DomesticLista,
        FormatType.DomesticT20,
        FormatType.HundredBall,
        FormatType.InTten,
        FormatType.YouthTest,
        FormatType.YouthODI,
        FormatType.YouthT20I,
        FormatType.NonDomesticTest,
        FormatType.NonDomesticODI,
        FormatType.NonDomesticT20,
    ],
};

export const FormatGroupMap: Record<string, FormatType[]> = {
    TEST: [
        FormatType.TEST,
        FormatType.DomesticFirstclass,
        FormatType.YouthTest,
        FormatType.NonDomesticTest,
    ],
    ODI: [
        FormatType.ODI,
        FormatType.DomesticLista,
        FormatType.YouthODI,
        FormatType.NonDomesticODI,
    ],
    T20I: [FormatType.T20I],
    T20: [
        FormatType.DomesticT20,
        FormatType.YouthT20I,
        FormatType.NonDomesticT20,
    ],
    T10: [FormatType.InTten],
};

export const FormatGroupArchive: Record<string, FormatType[]> = {
    TEST: [FormatType.TEST],
    ODI: [FormatType.ODI],
    T20I: [FormatType.T20I],
    IPL: [FormatType.DomesticT20],
};

export const formatTypePriority: Record<string, number> = {
    // International formats (highest priority)
    [FormatType.TEST]: 1,
    [FormatType.ODI]: 2,
    [FormatType.T20I]: 3,

    // Domestic formats
    [FormatType.DomesticFirstclass]: 4,
    [FormatType.DomesticLista]: 5,
    [FormatType.DomesticT20]: 6,

    // Other formats
    [FormatType.HundredBall]: 7,
    [FormatType.InTten]: 8,

    // Youth formats
    [FormatType.YouthTest]: 9,
    [FormatType.YouthODI]: 10,
    [FormatType.YouthT20I]: 11,

    // Non-domestic formats (lowest priority)
    [FormatType.NonDomesticTest]: 12,
    [FormatType.NonDomesticODI]: 13,
    [FormatType.NonDomesticT20]: 14,
};
